import styled from 'styled-components';
import { Stack } from 'components/Stack';

const InstructionWrapper = styled(Stack).attrs({
  isFullWidth: true,
  align: 'center',
  justify: 'center',
  direction: 'column',
})`
  flex: 1;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
`;

const InstructionText = styled.div`
  text-align: center;
  margin-top: 8px;
  font-size: 16px;
  line-height: 19px;
`;

export { InstructionWrapper, InstructionText };
